<template>
  <div>
    <reportings />
  </div>
</template>

<script>
  import Reportings from '@/components/reportings/Reportings.vue'

  export default {
    components: {
      Reportings
    }
  }
</script>
